<template>
  <v-tooltip
    :bottom='placement === "bottom"'
    :top='placement === "top"'
    :left='placement === "left"'
    :right='placement === "right"'
  >
    <template v-slot:activator="{ on }">
      <v-icon 
        :color="color"
        v-on="on"
        class="mr-2"
      >
        mdi-{{ icon }}
      </v-icon>
    </template>
    <span v-if='!!label'>{{ label }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'Tooltip',
    props: {
      label: {
        type: String,
        required: true,
        default: 'tooltip',
      },
      icon: {
        type: String,
        required: false,
        default: 'checkbox-blank-outline',
      },
      color: {
        type: String,
        required: false,
        default: 'grey lighten-1',
      },
      placement: {
        type: String,
        required: false,
        default: 'bottom',
      },
    },
    data: () => ({
    }),
    computed: {
    },
    created: function () {
    },
    methods: {
    },
  }
</script>